// extracted by mini-css-extract-plugin
module.exports = {"user":"user-story-card_user__3VgV5","name":"user-story-card_name__3KUuI","avatar":"user-story-card_avatar__1dM-z"};